import React from "react";
import { useTranslation } from "react-i18next";
import { EditOutlined, DeleteOutlined } from "us.icons";
import { RateActions } from "us.collection.admin/constants";
import { IItemMenu } from "us.collection.admin/components/StandardRates/Components/RatesTable";

/**
 * @description - Rates table action menu.
 * @link Design Document - https://unicorn-solutions.atlassian.net/wiki/spaces/USU/pages/3479208007/View+Standard+Rate+UI+Implementation
 * @author Ishan Udyoga <ishanud@unicorn-solutions.com>
 * @since 03/08/2024
 */
const ItemMenu: React.FC<IItemMenu> = ({
  actions = [RateActions.EDIT, RateActions.DELETE],
  onCallAction,
}) => {
  const { t } = useTranslation();

  return (
    <div className="table-more-content" data-testid="popover-content">
      {actions.includes(RateActions.EDIT) && (
        <div
          className="d-flex  flex-row more-item"
          data-testid="edit-btn"
          onClick={() => onCallAction(RateActions.EDIT)}
        >
          <div className="p-1">
            <EditOutlined />
          </div>
          <div className="p-1">{t("US.COLLECTION.COMMON:COMMON.EDIT")}</div>
        </div>
      )}
      {actions.includes(RateActions.DELETE) && (
        <div
          className="d-flex mb-2 flex-row more-item text-error"
          data-testid="delete-btn"
          onClick={() => onCallAction(RateActions.DELETE)}
        >
          <div className="p-1">
            <DeleteOutlined />
          </div>
          <div className="p-1">{t("US.COLLECTION.COMMON:COMMON.DELETE")}</div>
        </div>
      )}
    </div>
  );
};

export default ItemMenu;
